// src/components/atoms/HomePageHeader.js

import React from "react";
import { Typography, Grid } from "@mui/material";

const HomePageHeader = () => {

  return (
    <>
      {/* Header */}
      <Grid container justifyItems={"center"} sx={{ padding: 4 }}>
        <Grid item xs={12} lg={6} className="">
          <Typography variant="h4">Welcome to Kbean Challenges!</Typography>
        </Grid>
        
      </Grid>
    </>
  );
};

export default HomePageHeader;
